import {
  FACETED_SEARCH_RECEIVE,
} from '../Actions/FacetedSearch.action';
import {
  CART_SHOW_INFO,
} from '../Actions/Cart.action';
import { dataLayerGtmViewCart, pushEcommerce } from '../Services/Gtm.service';

let lastData;
const avoidLastDataPushEcommerce = (data) => {
  if (lastData && lastData === JSON.stringify(data)) {
    return;
  }
  if (data.ecommerce) {
    lastData = JSON.stringify(data);
  }
  pushEcommerce(data);
};

export const gtmMiddleware = ({ getState }) => (next) => (action) => {
  const { type, payload } = action;
  try {
    switch (type) {
      case CART_SHOW_INFO:
        if (payload.showInfo) {
          gtmShowMiniCart(getState().cart);
        }
        break;
      case FACETED_SEARCH_RECEIVE:
        if (payload.hasOwnProperty('gtmViewModel') && payload.gtmViewModel !== null) {
          avoidLastDataPushEcommerce(payload.gtmViewModel);
        }
        break;
      default:
        break;
    }
  } catch (err) {
    console.warn(err);
  }
  next(action);
};

const gtmShowMiniCart = ({ orderRows, gtmGrandTotal }) => {
  let currency = "";
  let gtmOrderRows = [];
  orderRows.forEach(row => {
    if (row.gtmEcommerceItem) {
      row.gtmEcommerceItem.index = gtmOrderRows.length;
      gtmOrderRows.push(row.gtmEcommerceItem);

      currency = row.gtmEcommerceItem.currency;
    }
  });
  
  if (gtmOrderRows.length > 0) {
    dataLayerGtmViewCart({currency, gtmGrandTotal, gtmOrderRows});
  }
}
